import { fragments } from '@/gql'
import gql from 'graphql-tag'
export default gql`
    query AwardPage($id: ID!, $masterLimit: Int) {
      AwardPage: Award(id: $id) {
        ...awardPeople
        ...awardFilms
        ...awardDetail
      }
    }
    ${fragments.awardDetail}
    ${fragments.artworkToArtifacts}
    ${fragments.artworkDetails}
    ${fragments.filmDetail}
    ${fragments.filmMasters}
    ${fragments.filmMasterDetail}
    ${fragments.stripDetail}
    ${fragments.filmFileDetail}
    ${fragments.filmHost}
    ${fragments.filmMasterPosterFrames}
    ${fragments.filmFiles}
    ${fragments.personDetail}
    ${fragments.personArtworks}
    ${fragments.awardPrizeArtworks}
    ${fragments.awardPrizeDetail}
    ${fragments.awardPeople}
    ${fragments.awardFilms}
    ${fragments.awardPrizeSim}
    ${fragments.filmBigAwards}
    ${fragments.awardAncestor}
    ${fragments.personBigAwards}
  `
